import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Reveal from '../../components/Reveal';
import usePageTitle from '../../hooks/usePageTitle';

export default function NotFound() {
  const { t } = useTranslation();
  usePageTitle(t('notFound.pageTitle'));
  return (
    <section className="band not-found">
      <div className="shell shell-narrow">
        <Reveal>
          <span className="eyebrow">{t('notFound.eyebrow')}</span>
          <h1>{t('notFound.title')}</h1>
          <p className="lede">{t('notFound.lede')}</p>
          <div className="hero-actions">
            <Link className="btn btn-primary" to="/">{t('notFound.backToHome')}</Link>
            <Link className="btn btn-outline" to="/contact">{t('notFound.contactUs')}</Link>
          </div>
          <div className="not-found-links">
            <Link to="/for-families">{t('nav.forFamilies')}</Link>
            <Link to="/for-nannies">{t('nav.forNannies')}</Link>
            <Link to="/faq">{t('nav.faq')}</Link>
            <Link to="/login">{t('notFound.signIn')}</Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
